import { useState } from "react";
import { ChoosePoint } from "./steps/shipping/servicePoints";
import dao from '../../../assets/img/dao.png'
import { FiEdit } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import { FaMapMarkerAlt } from "react-icons/fa";
import { BsCarFront } from "react-icons/bs";
import { useCheckout } from "./functions/useCheckout";


export function SingleShipment({ss, setShipment, setSelected, setOpenServicePoints, error, setError}) {
  return (
    <div className="">
      <div className="flex border border-neutral-300 text-sm sm:text-base">
        <label for={`levering_${ss.seller.id}`} className={`flex items-center gap-2 sm:gap-4 relative w-full px-4 py-2 border-r border-neutral-300 ${ss.deliveryType !== 1 ? "cursor-pointer" : ""}`}>
          <div className="img w-auto h-4 md:h-5 max-w-10 sm:max-w-none">
            <img src={dao} className="h-full w-full object-contain" />
          </div>
          <div className="flex flex-col justify-between">
            <p>Levering</p>
            <p className="font-semibold text-sm md:text-base">39 kr.</p>
          </div>
          <input type="radio"
            id={`levering_${ss.seller.id}`}
            checked={ss.deliveryType === 1}
            onChange={() => 
              setShipment(prev =>
                prev.map(s =>
                  s.seller.id === ss.seller.id
                    ? { ...s, deliveryType: 1 }
                    : s
                )
              ) & setError('')}
            className="absolute right-4 top-[50%] -translate-y-[50%]"
            />
        </label>
        <label for={`afhentning${ss.seller.id}`} className={`flex items-center gap-2 sm:gap-4 relative w-full px-4 py-2 ${ss.deliveryType !== 2 ? "cursor-pointer" : ""}`}>
          <div className="img w-auto h-6 md:h-7 max-w-10 sm:max-w-none">
            <BsCarFront className="h-full w-full object-contain" />
          </div>
          <div className="flex flex-col justify-between">
            <p>Afhent</p>
            <p className="font-semibold text-sm md:text-base">0 kr.</p>
          </div>
          <input type="radio"
            id={`afhentning${ss.seller.id}`}
            checked={ss.deliveryType === 2}
            onChange={() => 
              setShipment(prev =>
                prev.map(s =>
                  s.seller.id === ss.seller.id
                    ? { ...s, deliveryType: 2 }
                    : s
                )
              ) & setError('')}
            className="absolute right-4 top-[50%] -translate-y-[50%]"
            />
        </label>
      </div>
      <div className="border border-t-0 border-neutral-300" id={`leveringsdetaljer_${ss.seller.id}`}>
        {(ss.deliveryType === 1) ?
          <div class="hover:bg-neutral-100 cursor-pointer px-5 md:px-10 py-5 text-sm sm:text-base" onClick={() => setSelected(ss.seller.id) & setOpenServicePoints(true) & setError('')}>
            {(Object.keys(ss['service_point']).length !== 0) ?
              <div className="flex justify-between items-center w-full">
                <div className="space-y-1">
                  <p className="font-semibold">{ss.service_point['name']}</p>
                  <div className="address">
                    <p className="">{ss.service_point['address1']}</p>
                    <p>{ss.service_point['zipcode']}, {ss.service_point['city']}</p>
                  </div>
                </div>
                <FiEdit className="text-base lg:text-xl" />
              </div>
            :
              <div className="w-full">
                <div className="flex justify-between items-center w-full">
                  <div className="">
                    <h2 className="">Vælg en pakkeshop</h2>
                  </div>
                  <AiOutlinePlus className="text-base lg:text-xl" />
                </div>
                {(error !== '') ? <p className="text-sm font-medium text-gray-900 text-red-500">{error}</p> : ""}
              </div>
            }
          </div>
        :
          <div className="px-5 md:px-10 py-5 ring-1 ring-neutral-300 flex justify-between items-center text-xs md:text-base">
            <div className="space-y-1">
              <h2 className="font-semibold text-sm md:text-base">Afhentningsadresse</h2>
              <div className="">
                <p>{ss.pickup.pickup_address.postal_code} {ss.pickup.pickup_address.city}</p>
                <p className="text-xs md:text-sm">Addressen oplyses ved køb</p>
              </div>
            </div>
            <FaMapMarkerAlt className="text-lg lg:text-2xl" />
          </div>}
      </div>
    </div>
  )
}